interface CustomWindow extends Window {
  SERVER_YEAR: number;
}
declare let window: CustomWindow;

export const searchConstants = <const>{
  sorts: {
    relevance: {
      labelId: 'searchConstants.ts/1',
      event: 'sort_relevance',
    },
    chrono: {
      labelId: 'searchConstants.ts/2',
      event: 'sort_chrono',
    },
    antiChrono: {
      labelId: 'searchConstants.ts/3',
      event: 'sort_chrono_inverted',
    },
    commented: {
      labelId: 'searchConstants.ts/4',
      event: 'sort_commented',
    },
  },
  types: [
    {
      key: 'arret',
      labelId: 'searchConstants.ts/5',
    },
    {
      key: 'commentary',
      labelId: 'searchConstants.ts/6',
    },
    {
      key: 'law',
      labelId: 'searchConstants.ts/7',
    },
    { key: 'lawyer', labelId: 'searchConstants.ts/8' },
    {
      key: 'enterprise',
      labelId: 'searchConstants.ts/9',
    },
  ],

  filters: {
    juridiction: 'searchConstants.ts/10',
    dates: 'searchConstants.ts/11',
    inForceDates: 'searchConstants.ts/12',
    solution: 'searchConstants.ts/13',
    domaine: 'searchConstants.ts/14',
    ville: 'searchConstants.ts/15',
    publi: 'searchConstants.ts/16',
    parties: 'searchConstants.ts/17',
    exclude: 'searchConstants.ts/18',
    publisher: 'searchConstants.ts/19',
    textCode: 'searchConstants.ts/20',
    collectiveAgreements: 'searchConstants.ts/21',
    otherLegislation: 'searchConstants.ts/22',
    commentaryAccess: 'searchConstants.ts/23',
    pwCategory: 'searchConstants.ts/25',
    pwLegislativeFolder: 'searchConstants.ts/26',
  },
  years: {
    yearNow: window && window.SERVER_YEAR,
    yearNowMinusOne: window && window.SERVER_YEAR - 1,
    yearNowMinusFour: window && window.SERVER_YEAR - 4,
  },
};
